export default __webpack_public_path__ + "static/media/bg-boxed.06a417a8.jpg";